import ServiceContent from "@/model/Content/ServiceContent"

export interface ISkipassServiceContent {
    nbSlopesBlack?: number
    nbSlopesBlue?: number
    nbSlopesGreen?: number
    nbSlopesRed?: number
    slopeLength?: number
}

class SkipassServiceContent extends ServiceContent implements ISkipassServiceContent {

    nbSlopesBlack?: number
    nbSlopesBlue?: number
    nbSlopesGreen?: number
    nbSlopesRed?: number
    slopeLength?: number
    constructor(
        nbSlopesBlack?: number,
        nbSlopesBlue?: number,
        nbSlopesGreen?: number,
        nbSlopesRed?: number,
        slopeLength?: number,
    ) {
        super()
        this.nbSlopesBlack = nbSlopesBlack
        this.nbSlopesBlue = nbSlopesBlue
        this.nbSlopesGreen = nbSlopesGreen
        this.nbSlopesRed = nbSlopesRed
        this.slopeLength = slopeLength
    }

}

export default SkipassServiceContent